module.exports = "images/okoo.ee9265e9.png";